import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { GuardLinkService } from '../shared/services/guard-link.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private guardLinkService: GuardLinkService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url: string = state.url;
    console.log('AuthGuard#canActivate called ' + state);

    return this.checkLink(url);

    // return true;
  }

  checkLink(url: string): boolean {
    // new windows should bypass this when explicitly stated
    if (sessionStorage.getItem('newWindow') === 'true') {
      sessionStorage.setItem('newWindow', 'false');
      return true;
    }
    if (this.guardLinkService.isValidLink) { return true; }

    // Store the attempted URL for redirecting
    this.guardLinkService.redirectUrl = url;

    this.router.navigate(['/efs']);
    return false;
  }
}
